import { AxiosResponse } from "axios";
import { from, Observable } from "rxjs";
import {
  authenticatedFileDownloadHandler,
  defaultFileDownloadHandler,
} from "../../services/file-download-handlers.service";

export function downloadFile(
  url: string,
  authRequired: boolean,
  accept?: string
): Observable<AxiosResponse> {
  return from(
    authRequired
      ? authenticatedFileDownloadHandler(url, accept)
      : defaultFileDownloadHandler(url, accept)
  );
}

export const handleFileDownload = (response: AxiosResponse<Blob>, fallbackName: string) => {
  const fileName = response.headers["content-disposition"]
    ?.split("filename=")[1]
    .replaceAll('"', "");
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName ?? fallbackName);
  document.body.appendChild(link);
  link.click();
};
